import React, {useEffect, useState} from 'react';
import {useField} from 'react-final-form';

import ExchangeButtons from './Subcomponents/ExchangeButtons';
import ExchangeField from './Subcomponents/ExchangeField';
import ReasonDropdown from './Subcomponents/ReasonDropdown';
import ReturnField from './Subcomponents/ReturnField';
import {IReturnExchangeProps} from './IReturnExchange';

import styles from './ReturnExchange.module.scss';

const ReturnExchange = ({
	product,
	itemKey,
	returnReasons,
	exchangeReasons,
	shippingCountryCode
}: IReturnExchangeProps) => {
	const [returnReasonSelected, setReturnReasonSelected] = useState({});
	const [exchangeReasonSelected, setExchangeReasonSelected] = useState({});
	const variationAttributes = product?.getProductObject()?.variationAttributes || [];

	const returnCheckbox = useField(`returnProduct-${itemKey}`, {subscription: {value: true}});
	const exchangeCheckbox = useField(`exchangeProduct-${itemKey}`, {subscription: {value: true}});

	useEffect(() => {
		if (returnCheckbox.input.value) {
			exchangeCheckbox.input.onChange(false);
		}
	}, [returnCheckbox.input.value]);

	useEffect(() => {
		if (exchangeCheckbox.input.value) {
			returnCheckbox.input.onChange(false);
		}
	}, [exchangeCheckbox.input.value]);

	const isExchangeable = !variationAttributes.every(element => {
		if (element.values.length === 1) {
			return true;
		}
	});

	return (
		<div className={styles['return-create-step-1__returnExchange--container']}>
			<div className={styles['return-create-step-1__returnExchange--checkboxes']}>
				<ReturnField
					itemKey={itemKey}
					returnReasonSelected={returnReasonSelected}
					setReturnReasonSelected={setReturnReasonSelected}
				/>
				{isExchangeable && (
					<ExchangeField
						itemKey={itemKey}
						exchangeReasonSelected={exchangeReasonSelected}
						setExchangeReasonSelected={setExchangeReasonSelected}
					/>
				)}

			</div>
			<div className={styles['return-create-step-1__returnExchange--dropdown']}>
				{returnCheckbox.input.value ? (
					<ReasonDropdown
						fieldName="returnReason"
						itemKey={itemKey}
						reasons={returnReasons}
						reasonSelected={returnReasonSelected}
						setReasonSelected={setReturnReasonSelected}
					/>
				) : exchangeCheckbox.input.value ? (
					<>
						<ReasonDropdown
							fieldName="exchangeReason"
							itemKey={itemKey}
							reasons={exchangeReasons}
							reasonSelected={exchangeReasonSelected}
							setReasonSelected={setExchangeReasonSelected}
						/>
						<ExchangeButtons product={product} itemKey={itemKey} shippingCountryCode={shippingCountryCode} />
					</>
				) : null}
			</div>

		</div>
	);
};

export default ReturnExchange;